import React, { useEffect, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { IoClose } from "react-icons/io5"; // ✅ for a good-looking Close Icon

const VehicleGaugePopup = ({ vehicle, onInfoClick, onClose }) => {
    const speedChartRef = useRef();
    const fuelChartRef = useRef();

    useEffect(() => {
        if (!vehicle) return;
        setTimeout(() => {
            speedChartRef.current?.getEchartsInstance()?.resize();
            fuelChartRef.current?.getEchartsInstance()?.resize();
        }, 100);
        console.log("in the prop: ", vehicle);

    }, [vehicle]);

    if (!vehicle) return null;

    const commonGaugeOption = {
        type: "gauge",
        startAngle: 200,
        endAngle: -16,
        min: 0,
        axisLine: { lineStyle: { width: 12 } },
        progress: { show: true, width: 12 },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: {
            distance: 2,
            color: "#666",
            fontSize: 10,
            formatter: function (value) {
                if (value === 0 || value === 50 || value === 100) return value;
                return "";
            },
        },
        anchor: {
            show: true,
            size: 8,
            showAbove: true,
            itemStyle: { borderWidth: 2, borderColor: "#5470C6" },
        },
        pointer: { width: 3 },
        title: { show: false },
    };

    const speedOption = {
        series: [{
            ...commonGaugeOption,
            max: 120,
            axisLabel: {
                distance: 2,
                color: "#666",
                fontSize: 10,
                formatter: function (value) {
                    if (value === 0 || value === 60 || value === 120) return value;
                    return "";
                },
            },
            detail: {
                valueAnimation: true,
                fontSize: 18,
                offsetCenter: [0, "65%"],
                formatter: (v) => `${v} km/h`,
            },
            data: [{ value: parseFloat(vehicle.speed) || 0 }],
        }],
    };

    const fuelOption = {
        series: [{
            ...commonGaugeOption,
            max: 100,
            detail: {
                valueAnimation: true,
                fontSize: 18,
                offsetCenter: [0, "65%"],
                formatter: (v) => `${v} %`,
            },
            data: [{ value: parseFloat(vehicle.fuelLevel) || 0 }],
        }],
    };

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "150px",
            width: "100%",
        }}>
            {/* Header */}
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // ✅ push left and right
                width: "100%",
                // marginBottom: "10px",
            }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <HiOutlineInformationCircle
                        size={18}
                        style={{ marginRight: 10, cursor: "pointer" }}
                        onClick={() => onInfoClick?.(vehicle)}
                    />
                    <h3 style={{ margin: 0, fontSize: 18 }}>{vehicle.vehicleNo}</h3>
                </div>
                {/* Close Button */}
                <IoClose
                    size={22}
                    style={{ cursor: "pointer" }}
                    onClick={onClose}
                />
            </div>

            {/* Gauges Row */}
            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%",
            }}>
                {/* Speed Gauge */}
                <div style={{ minWidth: "60%", minHeight: "100px", marginLeft: "-15px"}}>
                    <ReactECharts
                        ref={speedChartRef}
                        option={speedOption}
                        notMerge={true}
                        lazyUpdate={true}
                        style={{ width: "100%", height: "100%" }}
                    />
                </div>

                {/* Fuel Gauge */}
                <div style={{ minWidth: "60%", minHeight: "100px" }}>
                    <ReactECharts
                        ref={fuelChartRef}
                        option={fuelOption}
                        notMerge={true}
                        lazyUpdate={true}
                        style={{ width: "100%", height: "100%" }}
                    />
                </div>
            </div>
        </div>
    );
};

export default VehicleGaugePopup;
